//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable functional/immutable-data */
/* eslint-disable functional/no-classes */
/* eslint-disable functional/no-this-expressions */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
// ReSharper disable InconsistentNaming



export class RoomMetadataBase implements IRoomMetadataBase {
    contentMetadataId!: string;
    roomName!: string;
    companyId!: string;
    description?: string;
    mapPath!: string;
    replayRecordingType!: ReplayRecordingType;
    maxVisibility!: VisibilityType;
    isSinglePlayer?: boolean;
    isVisibleInMenu?: boolean;
    isHub?: boolean;
    isAugmentedRealityCompatible?: boolean;
    isCreatableByExternalUsers?: boolean;
    allowUserFiles?: boolean;
    allowSinglePlayerMode?: boolean;
    maxUsers?: number;

    constructor(data?: IRoomMetadataBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.allowUserFiles = true;
            this.allowSinglePlayerMode = true;
            this.maxUsers = 20;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentMetadataId = _data["ContentMetadataId"];
            this.roomName = _data["RoomName"];
            this.companyId = _data["CompanyId"];
            this.description = _data["Description"];
            this.mapPath = _data["MapPath"];
            this.replayRecordingType = _data["ReplayRecordingType"];
            this.maxVisibility = _data["MaxVisibility"];
            this.isSinglePlayer = _data["IsSinglePlayer"];
            this.isVisibleInMenu = _data["IsVisibleInMenu"];
            this.isHub = _data["IsHub"];
            this.isAugmentedRealityCompatible = _data["IsAugmentedRealityCompatible"];
            this.isCreatableByExternalUsers = _data["IsCreatableByExternalUsers"];
            this.allowUserFiles = _data["AllowUserFiles"] !== undefined ? _data["AllowUserFiles"] : true;
            this.allowSinglePlayerMode = _data["AllowSinglePlayerMode"] !== undefined ? _data["AllowSinglePlayerMode"] : true;
            this.maxUsers = _data["MaxUsers"] !== undefined ? _data["MaxUsers"] : 20;
        }
    }

    static fromJS(data: any): RoomMetadataBase {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadataBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentMetadataId"] = this.contentMetadataId;
        data["RoomName"] = this.roomName;
        data["CompanyId"] = this.companyId;
        data["Description"] = this.description;
        data["MapPath"] = this.mapPath;
        data["ReplayRecordingType"] = this.replayRecordingType;
        data["MaxVisibility"] = this.maxVisibility;
        data["IsSinglePlayer"] = this.isSinglePlayer;
        data["IsVisibleInMenu"] = this.isVisibleInMenu;
        data["IsHub"] = this.isHub;
        data["IsAugmentedRealityCompatible"] = this.isAugmentedRealityCompatible;
        data["IsCreatableByExternalUsers"] = this.isCreatableByExternalUsers;
        data["AllowUserFiles"] = this.allowUserFiles;
        data["AllowSinglePlayerMode"] = this.allowSinglePlayerMode;
        data["MaxUsers"] = this.maxUsers;
        return data;
    }
}

export interface IRoomMetadataBase {
    contentMetadataId: string;
    roomName: string;
    companyId: string;
    description?: string;
    mapPath: string;
    replayRecordingType: ReplayRecordingType;
    maxVisibility: VisibilityType;
    isSinglePlayer?: boolean;
    isVisibleInMenu?: boolean;
    isHub?: boolean;
    isAugmentedRealityCompatible?: boolean;
    isCreatableByExternalUsers?: boolean;
    allowUserFiles?: boolean;
    allowSinglePlayerMode?: boolean;
    maxUsers?: number;
}

export class RoomMetadata extends RoomMetadataBase implements IRoomMetadata {
    roomMetadataId!: string;
    tagName?: string;
    notificationIconUrl?: string;
    libraryCardUrl?: string;
    libraryHeroUrl?: string;

    [key: string]: any;

    constructor(data?: IRoomMetadata) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.roomMetadataId = _data["RoomMetadataId"];
            this.tagName = _data["TagName"];
            this.notificationIconUrl = _data["NotificationIconUrl"];
            this.libraryCardUrl = _data["LibraryCardUrl"];
            this.libraryHeroUrl = _data["LibraryHeroUrl"];
        }
    }

    static fromJS(data: any): RoomMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["RoomMetadataId"] = this.roomMetadataId;
        data["TagName"] = this.tagName;
        data["NotificationIconUrl"] = this.notificationIconUrl;
        data["LibraryCardUrl"] = this.libraryCardUrl;
        data["LibraryHeroUrl"] = this.libraryHeroUrl;
        super.toJSON(data);
        return data;
    }
}

export interface IRoomMetadata extends IRoomMetadataBase {
    roomMetadataId: string;
    tagName?: string;
    notificationIconUrl?: string;
    libraryCardUrl?: string;
    libraryHeroUrl?: string;

    [key: string]: any;
}

export class RoomMetadataWithRequirements extends RoomMetadata implements IRoomMetadataWithRequirements {
    requirements!: ContentMetadataRequirements;

    [key: string]: any;

    constructor(data?: IRoomMetadataWithRequirements) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requirements = _data["Requirements"];
        }
    }

    static fromJS(data: any): RoomMetadataWithRequirements {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadataWithRequirements();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Requirements"] = this.requirements;
        super.toJSON(data);
        return data;
    }
}

export interface IRoomMetadataWithRequirements extends IRoomMetadata {
    requirements: ContentMetadataRequirements;

    [key: string]: any;
}

export class RoomMetadataWithoutId extends RoomMetadataBase implements IRoomMetadataWithoutId {
    tagId?: string;
    notificationIcon?: string;
    libraryCard?: string;
    libraryHero?: string;

    [key: string]: any;

    constructor(data?: IRoomMetadataWithoutId) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tagId = _data["TagId"];
            this.notificationIcon = _data["NotificationIcon"];
            this.libraryCard = _data["LibraryCard"];
            this.libraryHero = _data["LibraryHero"];
        }
    }

    static fromJS(data: any): RoomMetadataWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadataWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["TagId"] = this.tagId;
        data["NotificationIcon"] = this.notificationIcon;
        data["LibraryCard"] = this.libraryCard;
        data["LibraryHero"] = this.libraryHero;
        super.toJSON(data);
        return data;
    }
}

export interface IRoomMetadataWithoutId extends IRoomMetadataBase {
    tagId?: string;
    notificationIcon?: string;
    libraryCard?: string;
    libraryHero?: string;

    [key: string]: any;
}

export enum ContentMetadataRequirements {
    Optional = "Optional",
    AutoQueue = "AutoQueue",
    Required = "Required",
}

export enum ReplayRecordingType {
    Old = "Old",
    New = "New",
    NotAllowed = "NotAllowed",
}

export enum VisibilityType {
    Public = "Public",
    Internal = "Internal",
    Private = "Private",
}

export class Spotlight implements ISpotlight {
    roomMetadata!: RoomMetadata;
    order!: number;
    contentSize!: number;
    spotlightId!: string;

    constructor(data?: ISpotlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roomMetadata = new RoomMetadata();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomMetadata = _data["RoomMetadata"] ? RoomMetadata.fromJS(_data["RoomMetadata"]) : new RoomMetadata();
            this.order = _data["Order"];
            this.contentSize = _data["ContentSize"];
            this.spotlightId = _data["SpotlightId"];
        }
    }

    static fromJS(data: any): Spotlight {
        data = typeof data === 'object' ? data : {};
        let result = new Spotlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoomMetadata"] = this.roomMetadata ? this.roomMetadata.toJSON() : <any>undefined;
        data["Order"] = this.order;
        data["ContentSize"] = this.contentSize;
        data["SpotlightId"] = this.spotlightId;
        return data;
    }
}

export interface ISpotlight {
    roomMetadata: RoomMetadata;
    order: number;
    contentSize: number;
    spotlightId: string;
}

export class SpotlightWithoutId implements ISpotlightWithoutId {
    roomMetadataId!: string;
    /** Order cannot be negative. */
    order!: number;

    constructor(data?: ISpotlightWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomMetadataId = _data["RoomMetadataId"];
            this.order = _data["Order"];
        }
    }

    static fromJS(data: any): SpotlightWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new SpotlightWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoomMetadataId"] = this.roomMetadataId;
        data["Order"] = this.order;
        return data;
    }
}

export interface ISpotlightWithoutId {
    roomMetadataId: string;
    /** Order cannot be negative. */
    order: number;
}

export enum ContentPlatform {
    Windows = "Windows",
    Android = "Android",
}

export enum AvatarType {
    Stylized = "Stylized",
    Realistic = "Realistic",
}

export class ContentWithFiles implements IContentWithFiles {
    content!: Content;
    files!: FileDescriptor[];

    constructor(data?: IContentWithFiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.content = new Content();
            this.files = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["Content"] ? Content.fromJS(_data["Content"]) : new Content();
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileDescriptor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContentWithFiles {
        data = typeof data === 'object' ? data : {};
        let result = new ContentWithFiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Content"] = this.content ? this.content.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContentWithFiles {
    content: Content;
    files: FileDescriptor[];
}

export class Content implements IContent {
    contentId!: string;
    contentMetadataId?: string;
    version!: string;
    unrealEngineVersion?: string | undefined;
    size!: number;
    isIncludedInCoreArtifact!: boolean;
    isStandalone!: boolean;
    contentType!: string;
    updatedAt!: Date;
    buildData?: string | undefined;

    constructor(data?: IContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentId = _data["ContentId"];
            this.contentMetadataId = _data["ContentMetadataId"];
            this.version = _data["Version"];
            this.unrealEngineVersion = _data["UnrealEngineVersion"];
            this.size = _data["Size"];
            this.isIncludedInCoreArtifact = _data["IsIncludedInCoreArtifact"];
            this.isStandalone = _data["IsStandalone"];
            this.contentType = _data["ContentType"];
            this.updatedAt = _data["UpdatedAt"] ? new Date(_data["UpdatedAt"].toString()) : <any>undefined;
            this.buildData = _data["BuildData"];
        }
    }

    static fromJS(data: any): Content {
        data = typeof data === 'object' ? data : {};
        let result = new Content();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentId"] = this.contentId;
        data["ContentMetadataId"] = this.contentMetadataId;
        data["Version"] = this.version;
        data["UnrealEngineVersion"] = this.unrealEngineVersion;
        data["Size"] = this.size;
        data["IsIncludedInCoreArtifact"] = this.isIncludedInCoreArtifact;
        data["IsStandalone"] = this.isStandalone;
        data["ContentType"] = this.contentType;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["BuildData"] = this.buildData;
        return data;
    }
}

export interface IContent {
    contentId: string;
    contentMetadataId?: string;
    version: string;
    unrealEngineVersion?: string | undefined;
    size: number;
    isIncludedInCoreArtifact: boolean;
    isStandalone: boolean;
    contentType: string;
    updatedAt: Date;
    buildData?: string | undefined;
}

export class ManifestEntry implements IManifestEntry {
    filePath!: string;
    size!: number;
    md5!: string;

    constructor(data?: IManifestEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["FilePath"];
            this.size = _data["Size"];
            this.md5 = _data["Md5"];
        }
    }

    static fromJS(data: any): ManifestEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ManifestEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilePath"] = this.filePath;
        data["Size"] = this.size;
        data["Md5"] = this.md5;
        return data;
    }
}

export interface IManifestEntry {
    filePath: string;
    size: number;
    md5: string;
}

export class FileDescriptor implements IFileDescriptor {
    filePath!: string;
    size!: number;
    md5!: string;
    uri!: string;
    cdnUri!: string;
    delete!: boolean;

    constructor(data?: IFileDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.delete = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["FilePath"];
            this.size = _data["Size"];
            this.md5 = _data["Md5"];
            this.uri = _data["Uri"];
            this.cdnUri = _data["CdnUri"];
            this.delete = _data["Delete"] !== undefined ? _data["Delete"] : false;
        }
    }

    static fromJS(data: any): FileDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new FileDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilePath"] = this.filePath;
        data["Size"] = this.size;
        data["Md5"] = this.md5;
        data["Uri"] = this.uri;
        data["CdnUri"] = this.cdnUri;
        data["Delete"] = this.delete;
        return data;
    }
}

export interface IFileDescriptor {
    filePath: string;
    size: number;
    md5: string;
    uri: string;
    cdnUri: string;
    delete: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}